import React, { useEffect, useState } from 'react'
import PureTitle from '../PureTitle'
import styles from './styles.module.scss'
import parentStyles from '../../styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'
import Calendar from 'srcReact/components/common2/Calendar'
import TimePicker from 'srcReact/components/common2/TimePicker'
import { useDispatch, useSelector } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import RadioButtonGroup from 'srcReact/components/common2/RadioButtonGroup'
import Label from 'srcReact/components/common2/Label'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import WeekdayDropdown from 'srcReact/components/common2/WeekdayDropdown'
import { isEmpty } from 'lodash'
import Input from 'srcReact/components/common2/Input'
import Spinner from 'srcReact/components/common2/Spinner'
import {
  convertUTCToTimezone,
  formatLastUpdateDate,
  isSameDate,
  roundTimeQuarterHour
} from 'srcReact/helpers/datetimeHelper'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Timezone from 'srcReact/components/common2/Timezone'
import Checkbox from 'srcReact/components/common2/Checkbox'

export default function MixrTiming({
  editMode,
  showNextSection,
  hideNextButton,
  isMobile,
  openEditMixrPopup,
  setDataToUpdateForRecMixr,
  previewEditMode
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: {
      isNative,
      timezone: { loading: timezoneLoading, value: timezoneValue }
    },
    login: { user: loggedInUser },
    mixr: {
      mixr: {
        id: mixrId,
        recurrence,
        fees,
        location: mixrLocation,
        local_start_at: startDatetime,
        local_end_at: endDatetime,
        attending_type
      },
      recurEndDateError,
      editSuccess,
      editLoading,
      recurrentMixrsCount,
      loadingGetMixrEndDate
    }
  } = useSelector((state) => state)

  const [startDateRef, setStartDateRef] = useState(null)
  const [startTimeRef, setStartTimeRef] = useState(null)
  const [endDateRef, setEndDateRef] = useState(null)
  const [endTimeRef, setEndTimeRef] = useState(null)

  const [inValidDateError, setInValidDateError] = useState('')
  const [startingEndTime, setStartingEndTime] = useState(null)
  const [showInvalidEndDateError, setShowInvalidEndDateError] = useState(false)
  const [buttonClicked, setButtonClicked] = useState(false)
  const [hasSelectedDaysError, setHasSelectedDaysError] = useState(false)
  const [selectedWeekdayError, setSelectedWeekdayError] = useState('')
  const [selectedNthWeekOfMonthError, setSelectedNthWeekOfMonthError] = useState('')
  const [valueChanged, setValueChanged] = useState(false)
  const [endTimevalueChanged, setEndTimevalueChanged] = useState(false)
  const [untilDateIsSet, setUntilDateIsSet] = useState(false)
  const [initialTimezone, setInitialTimezone] = useState(null)
  const [allDayMixr, setAllDayMixr] = useState(false)
  const [startDate, setStartDate] = useState({
    value: null,
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [endDate, setEndDate] = useState({
    value: null,
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const [untilDate, setUntilDate] = useState({
    value: null,
    hasError: false,
    errorMessage: ''
  })

  const [startTime, setStartTime] = useState({
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [endTime, setEndTime] = useState({
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [everyMonth, setEveryMonth] = useState({
    value: 1,
    hasError: false,
    errorMessage: ''
  })

  const [selectedRecurrenceId, setSelectedRecurrenceId] = useState(1)
  const [selectedDays, setSelectedDays] = useState([])
  const [selectedNthWeekOfMonth, setSelectedNthWeekOfMonth] = useState({
    value: -1,
    label: t('global.select')
  })
  const [everyNMonth, setEveryNMonth] = useState(1)
  const [selectedRepeatType, setSelectedRepeatType] = useState({
    value: 'weekly',
    label: t('event.create.timing.weekly')
  })
  const [selectedMixrEndsOn, setSelectedMixrEndsOn] = useState({
    value: 0,
    label: t('event.create.mixrEndOnValues.sameDay')
  })
  const [selectedEveryNTimes, setSelectedEveryNTimes] = useState({
    value: '1',
    label: t('event.create.repeatingWeeks.1week')
  })

  const [selectedWeekday, setSelectedWeekday] = useState(null)

  const validate = (startingDate, startingTime, endingDate, endingTime) => {
    let isValid = true
    if (!previewEditMode) {
      resetErrors()
    }
    if (recurrence?.is_parent_event !== 1 || !editMode) {
      if (startTime && isEmpty(startTime.value) && startTimeRef && startTimeRef.current) {
        startTimeRef.current.focus()
        setStartTime({
          ...startTime,
          hasError: true,
          errorMessage: t('event.create.clientErrors.startTimeRequired')
        })

        isValid = false
      }

      if (endTime && isEmpty(endTime.value) && endTimeRef && endTimeRef.current) {
        endTimeRef.current.focus()
        setEndTime({
          ...endTime,
          hasError: true,
          errorMessage: t('event.create.clientErrors.endTimeRequired')
        })

        isValid = false
      }
      const sDate = startingDate || startDate.value
      const sTime = startingTime || startTime.value
      const eDate = endingDate || endDate.value
      const eTime = endingTime || endTime.value

      const startFullDateTime =
        sDate && sTime
          ? new Date(`${sDate.getFullYear()}-${sDate.getMonth() + 1}-${sDate.getDate()} ${sTime}`).getTime()
          : null

      const endFullDateTime =
        eDate && eTime
          ? new Date(`${eDate.getFullYear()}-${eDate.getMonth() + 1}-${eDate.getDate()} ${eTime}`).getTime()
          : null

      if (!editMode || previewEditMode) {
        const untilDateTime = untilDate && untilDate.value && untilDate.value.getTime()
        if (selectedRecurrenceId === 0) {
          if (!untilDateTime) {
            setUntilDate({
              ...untilDate,
              hasError: true,
              errorMessage: t('event.create.clientErrors.untilDateRequired')
            })

            isValid = false
          } else if (startFullDateTime && startFullDateTime > untilDateTime) {
            setUntilDate({
              ...untilDate,
              hasError: true,
              errorMessage: t('event.create.clientErrors.inValidUntilDateError')
            })
            isValid = false
          }
        }
      }

      let currentDateTime = new Date().getTime()
      let utcOffset = mixrLocation?.timezone?.UTCOffset || mixrLocation?.timezone?.utc_offset
      const converted = convertUTCToTimezone(currentDateTime, utcOffset)
      const currentTZDateTime = new Date(
        `${converted.year()}-${converted.month() + 1}-${converted.date()} ${converted.hour()}:${converted.minute()}`
      ).getTime()
      const currentTZDate = new Date(`${converted.year()}-${converted.month() + 1}-${converted.date()} `).getTime()

      if (startFullDateTime && endFullDateTime && startFullDateTime > endFullDateTime) {
        setInValidDateError(t('event.create.clientErrors.inValidDateError'))
        isValid = false
      } else if (
        selectedRecurrenceId === 1 &&
        ((startFullDateTime && startFullDateTime < currentTZDateTime) ||
          (endFullDateTime && endFullDateTime < currentTZDateTime)) // check for time too. time cannot be past
      ) {
        setInValidDateError(t('event.create.clientErrors.pastMixrError'))
        isValid = false
      } else if (
        selectedRecurrenceId === 0 &&
        ((startFullDateTime && startFullDateTime < currentTZDate) ||
          (endFullDateTime && endFullDateTime < currentTZDate)) //time can be past
      ) {
        setInValidDateError(t('event.create.clientErrors.pastMixrError'))
        isValid = false
      } else {
        if (!startFullDateTime) {
          setInValidDateError(t('event.create.clientErrors.startDateRequired'))
          isValid = false
        } else if (!endFullDateTime) {
          setInValidDateError(t('event.create.clientErrors.endDateRequired'))
          isValid = false
        } else {
          setInValidDateError('')
        }
      }
      if (selectedRecurrenceId === 0 && selectedRepeatType.value === 'weekly' && selectedDays.length === 0) {
        setHasSelectedDaysError(true)
        isValid = false
      }

      if (selectedRecurrenceId === 0 && selectedRepeatType.value === 'monthly') {
        if (selectedNthWeekOfMonth.value === -1) {
          setSelectedNthWeekOfMonthError(t('event.create.clientErrors.required'))
          isValid = false
        }
        if (selectedWeekday == null || (selectedWeekday && selectedWeekday.value === -1)) {
          setSelectedWeekdayError(t('event.create.clientErrors.required'))
          isValid = false
        }
      }
    }

    // if (!validatePricingDetails()) {
    //   isValid = false
    // }

    return isValid
  }
  const handleNext = () => {
    setInValidDateError('')
    const isValid = validate()
    if (isValid) {
      if (selectedRecurrenceId === 1) {
        showNextSection()
      } else {
        setButtonClicked(true)
        validateRecurMixrEndDate()
      }
      //showNextSection()
    }
  }
  useEffect(() => {
    dispatch(mixrActions.getFeeCategories())
    const dayOfWeek =
      recurrence && recurrence.day_of_week >= 0 ? recurrence.day_of_week : new Date().getDay().toString()

    dispatch(
      mixrActions.setMixrData([
        {
          key: 'recurrence',
          value: {
            ...recurrence,
            day_of_week: dayOfWeek
          }
        }
      ])
    )
    const startTimeValue = roundTimeQuarterHour(new Date())
    setStartTime({
      ...startTime,
      value: startTimeValue
    })
    setEndTime({
      ...endTime,
      value: roundTimeQuarterHour(new Date(), 1)
    })
    setStartingEndTime(startTimeValue)
  }, [])

  //when mixr form is not filled from draft/mixr and is a fresh form
  useEffect(() => {
    if (!previewEditMode && !editMode) {
      setStartDate({
        ...startDate,
        value: new Date()
      })
      setEndDate({
        ...endDate,
        value: new Date()
      })
    }
  }, [previewEditMode])

  //this useeffect is used to store inital timezone value when mixr location data is updated from api
  //it is used for edit mode only
  //The code inside is execute only once,until initialTimezone is null
  useEffect(() => {
    if (!initialTimezone && mixrLocation?.timezone && mixrLocation.timezone.timeZoneId) {
      //Because Timezone component loads getTimezoneByLatLong first,  we are setting initial timezone after everything is stable
      setTimeout(() => setInitialTimezone(mixrLocation.timezone), 1500)
    }
  }, [mixrLocation?.timezone?.timeZoneId])

  useEffect(() => {
    if (editMode || previewEditMode) {
      const { type: recurrenceType, end_date } = recurrence
      if (recurrenceType === 'none') {
        setSelectedRecurrenceId(1)
      } else {
        setSelectedRecurrenceId(0)
        const type = repeatTypes.find((r) => r.value === recurrenceType)
        setSelectedRepeatType(type)
        if (end_date) {
          let dateParts = end_date.split('-')
          let date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2])
          setUntilDate({
            ...untilDate,
            value: date,
            errorMessage: '',
            hasError: false
          })
          if (editMode) {
            setUntilDateIsSet(true)
          }
        }
      }
    }
  }, [recurrence && recurrence.type])

  useEffect(() => {
    if (editMode && editSuccess) {
      setValueChanged(false)
    }
  }, [editSuccess])

  useEffect(() => {
    if (editMode || previewEditMode) {
      if (mixrLocation && mixrLocation.timezone) {
        //here we are setting the location timezone after 1 sec, not to conflict with getTimezoneByLatLong call on Timezone component
        setTimeout(
          () =>
            dispatch(
              mixrActions.setMixrData([
                { key: 'location', value: { ...mixrLocation, timezone: mixrLocation.timezone } }
              ])
            ),
          1000
        )

        const startingDate = new Date(startDatetime)
        const validStartDate = startingDate instanceof Date && !isNaN(startingDate) ? startingDate : ''
        setStartDate({
          ...startDate,
          value: validStartDate
        })
        let startingTime = ''
        if (validStartDate) {
          let hrs = validStartDate.getHours()
          hrs = hrs < 10 ? `0${hrs}` : hrs
          let mins = validStartDate.getMinutes()
          mins = mins < 10 ? `0${mins}` : mins
          startingTime = `${hrs}:${mins}`
          setStartTime({
            ...startTime,
            value: startingTime
          })
          setStartingEndTime(startingTime)
        }

        const endingDate = new Date(endDatetime)
        const validEndDate = endingDate instanceof Date && !isNaN(endingDate) ? endingDate : ''
        setEndDate({
          ...endDate,
          value: validEndDate
        })
        let endingTime = ''
        if (validStartDate && validEndDate) {
          let hrsEnd = validEndDate.getHours()
          hrsEnd = hrsEnd < 10 ? `0${hrsEnd}` : hrsEnd
          let minsEnd = validEndDate.getMinutes()
          minsEnd = minsEnd < 10 ? `0${minsEnd}` : minsEnd
          endingTime = `${hrsEnd}:${minsEnd}`
          setEndTime({
            ...endTime,
            value: endingTime
          })
        }

        if (recurrence.type !== 'none' && validEndDate && validStartDate) {
          let diffDays = validEndDate.getDate() - validStartDate.getDate()
          const endsOn = mixrEndsOnTypes.find((x) => x.value === diffDays)

          setSelectedMixrEndsOn(endsOn)
        }
        // if (previewEditMode) {//commented based on 1205537349060566
        //   //show error message when user selects past mixr or past draft
        //   validate(validStartDate, startingTime, validEndDate, endingTime)
        // }
      }
    }
  }, [startDatetime, endDatetime])

  const recurrenceTypes = [
    { value: 1, label: t('event.create.timing.oneTime') },
    { value: 0, label: t('event.create.timing.recurring') }
  ]

  const days = [
    {
      value: 1,
      label: t('weekdays.short.monday'),
      full: t('weekdays.full.monday')
    },
    {
      value: 2,
      label: t('weekdays.short.tuesday'),
      full: t('weekdays.full.tuesday')
    },
    {
      value: 3,
      label: t('weekdays.short.wednesday'),
      full: t('weekdays.full.wednesday')
    },
    {
      value: 4,
      label: t('weekdays.short.thursday'),
      full: t('weekdays.full.thursday')
    },
    {
      value: 5,
      label: t('weekdays.short.friday'),
      full: t('weekdays.full.friday')
    },
    {
      value: 6,
      label: t('weekdays.short.saturday'),
      full: t('weekdays.full.saturday')
    },
    {
      value: 0,
      label: t('weekdays.short.sunday'),
      full: t('weekdays.full.sunday')
    }
  ]

  const [repeatTypes] = useState([
    {
      value: 'daily',
      label: t('event.create.timing.daily')
    },
    {
      value: 'weekly',
      label: t('event.create.timing.weekly')
    },
    {
      value: 'monthly',
      label: t('event.create.timing.monthly')
    }
  ])

  const [nthWeekOfMonth] = useState([
    {
      value: -1,
      label: t('global.select')
    },
    {
      value: 1,
      label: t('event.create.numberedDay.1st')
    },
    {
      value: 2,
      label: t('event.create.numberedDay.2nd')
    },
    {
      value: 3,
      label: t('event.create.numberedDay.3rd')
    },
    {
      value: 4,
      label: t('event.create.numberedDay.4th')
    }
  ])

  const [everyNWeeks] = useState([
    {
      value: 1,
      label: t('event.create.repeatingWeeks.1week')
    },
    {
      value: 2,
      label: t('event.create.repeatingWeeks.2weeks')
    },
    {
      value: 3,
      label: t('event.create.repeatingWeeks.3weeks')
    },
    {
      value: 4,
      label: t('event.create.repeatingWeeks.4weeks')
    },
    {
      value: 5,
      label: t('event.create.repeatingWeeks.5weeks')
    }
  ])

  const [mixrEndsOnTypes] = useState([
    {
      value: 0,
      label: t('event.create.mixrEndOnValues.sameDay')
    },
    {
      value: 1,
      label: t('event.create.mixrEndOnValues.nextDay')
    },
    {
      value: 2,
      label: t('event.create.mixrEndOnValues.2ndDay')
    },
    {
      value: 3,
      label: t('event.create.mixrEndOnValues.3rdDay')
    },
    {
      value: 4,
      label: t('event.create.mixrEndOnValues.4thDay')
    },
    {
      value: 5,
      label: t('event.create.mixrEndOnValues.5thDay')
    },
    {
      value: 6,
      label: t('event.create.mixrEndOnValues.6thDay')
    }
  ])

  const handleRecurrenceChange = (e) => {
    setValueChanged(true)
    const value = e.target.value
    setSelectedRecurrenceId(parseInt(value))
    let endDt = new Date(startDate.value)
    if (selectedMixrEndsOn?.value > 0) {
      endDt.setDate(startDate.value.getDate() + selectedMixrEndsOn.value)
    }
    setEndDate({
      ...endDate,
      value: endDt,
      hasError: false,
      errorMessage: ''
    })

    if (!editMode || previewEditMode) {
      if (value == 1) {
        dispatch(mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, type: 'none' } }]))
      } else {
        dispatch(
          mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, type: selectedRepeatType.value } }])
        )
      }
    }
    resetErrors()
  }

  const resetErrors = () => {
    setInValidDateError('')
    setUntilDate({
      ...untilDate,
      errorMessage: '',
      hasError: false
    })
    setSelectedNthWeekOfMonthError('')
    setSelectedWeekdayError('')
    setHasSelectedDaysError(false)
  }

  const handleRepeatTypeChange = (type) => {
    setValueChanged(true)
    setSelectedRepeatType(type)
    if (!editMode || previewEditMode) {
      dispatch(mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, type: type.value } }]))
    }
  }

  const handleWeekdayChange = (weekday) => {
    setValueChanged(true)
    setSelectedWeekday(weekday.value)
    if (weekday.value === -1) {
      setSelectedWeekdayError(t('event.create.clientErrors.required'))
    } else {
      setSelectedWeekdayError('')
    }
    if (!editMode || previewEditMode) {
      dispatch(mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, day_of_week: weekday.value } }]))
    }
  }
  const handleEveryNWeeksChange = (week) => {
    setValueChanged(true)
    setSelectedEveryNTimes(week)
    if (!editMode || previewEditMode) {
      dispatch(mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, weeks_count: week.value } }]))
    }
  }

  const handleDaysSelection = (day) => {
    setValueChanged(true)
    setHasSelectedDaysError(false)
    const isAlreadyExist = selectedDays.filter((d) => d === day.value).length > 0
    if (isAlreadyExist) {
      const updated = selectedDays.filter((d) => d !== day.value)
      setSelectedDays([...updated])
      if (!editMode || previewEditMode) {
        dispatch(
          mixrActions.setMixrData([
            { key: 'recurrence', value: { ...recurrence, days_of_week: [...updated].join(',') } }
          ])
        )
      }
      if (updated.length === 0) {
        setHasSelectedDaysError(true)
      }
    } else {
      setSelectedDays([...selectedDays, day.value])
      if (!editMode || previewEditMode) {
        dispatch(
          mixrActions.setMixrData([
            { key: 'recurrence', value: { ...recurrence, days_of_week: [...selectedDays, day.value].join(',') } }
          ])
        )
      }
    }
  }

  const handleNthWeekOfMonthChange = (item) => {
    setValueChanged(true)
    setSelectedNthWeekOfMonth(item)
    if (item.value === -1) {
      setSelectedNthWeekOfMonthError(t('event.create.clientErrors.required'))
    } else {
      setSelectedNthWeekOfMonthError('')
    }
    if (!editMode) {
      dispatch(mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, week_of_month: item.value } }]))
    }
  }

  const handleMixrEndsOnChange = (item) => {
    setValueChanged(true)
    let endDt = new Date(startDate.value)
    if (item.value > 0) {
      endDt.setDate(startDate.value.getDate() + item.value)
    }
    setEndDate({
      ...endDate,
      value: endDt,
      hasError: false,
      errorMessage: ''
    })
    setSelectedMixrEndsOn(item)
  }

  const handleStartDateChange = (value) => {
    setValueChanged(true)
    setInValidDateError('')
    setStartDate({
      ...startDate,
      value: value,
      hasError: false,
      errorMessage: ''
    })
    setEndDate({
      ...endDate,
      value: value,
      hasError: false,
      errorMessage: ''
    })
    if (selectedRecurrenceId === 0) {
      setSelectedMixrEndsOn({ value: 0, label: t('event.create.mixrEndOnValues.sameDay') })
    }
  }

  const handleEndDateChange = (value) => {
    setValueChanged(true)
    setEndDate({
      ...endDate,
      value: value,
      hasError: false,
      errorMessage: ''
    })
    const isMixrOnSameDay = isSameDate(value, startDate.value)
    if (!isMixrOnSameDay) {
      setStartingEndTime(null)
    } else {
      setStartingEndTime(startTime.value)
    }
  }

  const handleStartTimeChange = (time) => {
    setValueChanged(true)
    setStartTime({
      ...startTime,
      value: time.value,
      errorMessage: '',
      hasError: false
    })
    //1203688745367695 - do not reset endtime if it is already set manually by user
    if (!endTimevalueChanged) {
      const updatedEndTime = add1hourToTime(time)
      setEndTime({
        ...endTime,
        value: updatedEndTime,
        errorMessage: '',
        hasError: false
      })
      setStartingEndTime(time.value)
    }
  }

  const handleEndTimeChange = (time) => {
    setValueChanged(true)
    setEndTimevalueChanged(true)
    setEndTime({
      ...endTime,
      value: time.value,
      errorMessage: '',
      hasError: false
    })
  }

  const handleUntilDateChange = (value) => {
    const startFullDateTime =
      startDate.value && startTime.value
        ? new Date(
            `${startDate.value.getFullYear()}-${startDate.value.getMonth() + 1}-${startDate.value.getDate()} ${
              startTime.value
            }`
          ).getTime()
        : null

    const untilDateTime = value && value.getTime()
    if (startFullDateTime && startFullDateTime > untilDateTime) {
      setUntilDate({
        ...untilDate,
        hasError: true,
        errorMessage: t('event.create.clientErrors.inValidUntilDateError')
      })
    } else {
      setValueChanged(true)
      setUntilDate({
        ...untilDate,
        value: value,
        errorMessage: '',
        hasError: false
      })
      if (!previewEditMode) {
        setUntilDateIsSet(true)
      }
    }
  }

  useEffect(() => {
    if (selectedRecurrenceId === 0 && !untilDateIsSet) {
      if (previewEditMode) {
        const strDate = recurrence.end_date
        if (strDate) {
          const arrDate = strDate.split('-')
          const date = new Date(arrDate[0], (parseInt(arrDate[1]) - 1).toString(), arrDate[2])
          setUntilDate({
            ...untilDate,
            value: date
          })
        }
      } else {
        setUntilDate({
          ...untilDate,
          value: null
        })
      }

      validateRecurMixrEndDate()
    }
  }, [
    startDate,
    endDate,
    startTime,
    endTime,
    selectedRecurrenceId,
    selectedRepeatType,
    // untilDate,
    selectedEveryNTimes,
    selectedDays,
    selectedWeekday,
    everyNMonth,
    selectedNthWeekOfMonth
  ])

  const validateRecurMixrEndDate = () => {
    if (!startDate.value) {
      setInValidDateError(t('event.create.clientErrors.startDateRequired'))
      return false
    }
    if (!endDate.value) {
      setInValidDateError(t('event.create.clientErrors.endDateRequired'))
      return false
    }
    const startFullDateTime = new Date(
      `${startDate.value.getFullYear()}-${startDate.value.getMonth() + 1}-${startDate.value.getDate()} ${
        startTime.value
      }`
    )

    const endFullDateTime = new Date(
      `${endDate.value.getFullYear()}-${endDate.value.getMonth() + 1}-${endDate.value.getDate()} ${endTime.value}`
    )

    if (selectedRecurrenceId === 0) {
      const formattedStartDate = formatLastUpdateDate(startFullDateTime, appConstantSettings.DATE_FORMAT7, t)
      const fomattedEndDate = formatLastUpdateDate(endFullDateTime, appConstantSettings.DATE_FORMAT7, t)
      const formattedUntilDate = untilDate.value
        ? formatLastUpdateDate(untilDate.value, appConstantSettings.DATE_FORMAT7, t)
        : null

      if (selectedRepeatType.value === 'daily') {
        dispatch(
          mixrActions.getRecurrenceEndDate(
            formattedStartDate,
            fomattedEndDate,
            selectedRepeatType.value,
            formattedUntilDate
          )
        )
      } else if (selectedRepeatType.value === 'weekly') {
        const strSelectedDays = selectedDays.length > 0 ? selectedDays.map((x) => x).join(',') : ''
        dispatch(
          mixrActions.getRecurrenceEndDate(
            formattedStartDate,
            fomattedEndDate,
            selectedRepeatType.value,
            formattedUntilDate,
            selectedEveryNTimes.value,
            strSelectedDays
          )
        )
      } else if (selectedRepeatType.value === 'monthly') {
        dispatch(
          mixrActions.getRecurrenceEndDate(
            formattedStartDate,
            fomattedEndDate,
            selectedRepeatType.value,
            formattedUntilDate,
            0,
            '',
            everyNMonth,
            selectedWeekday,
            selectedNthWeekOfMonth.value
          )
        )
      }
    }
  }

  useEffect(() => {
    if (!loadingGetMixrEndDate) {
      if (buttonClicked) {
        if ((recurEndDateError && recurEndDateError.length > 0) || recurrentMixrsCount === 0) {
          setShowInvalidEndDateError(true)
        } else {
          setShowInvalidEndDateError(false)
          showNextSection()
        }
        setButtonClicked(false)
      }
      //This code will populate until date automatically based on  on several recurrent properties change (api: /v2/mixr/creation/recurrence/get-max-end-date?)
      // if (!editMode && endMixrData && endMixrData.max_end_date) {
      //   setUntilDate({
      //     ...untilDate,
      //     hasError: recurEndDateError.length > 0,
      //     value:
      //       recurEndDateError.length > 0
      //         ? null
      //         : untilDate.value
      //         ? new Date(untilDate.value)
      //         : new Date(endMixrData.max_end_date)
      //   })
      // }
    }
  }, [recurEndDateError, recurrentMixrsCount, buttonClicked, loadingGetMixrEndDate])

  useEffect(() => {
    if (editMode || previewEditMode) {
      const { days_of_week } = recurrence
      if (days_of_week && days_of_week.length > 0) {
        setSelectedDays(
          days_of_week.split(',').map(function (item) {
            return parseInt(item, 10)
          })
        )
      }
    }
  }, [recurrence && recurrence.days_of_week])

  useEffect(() => {
    if ((editMode || previewEditMode) && (recurrence.weeks_count || recurrence.interval)) {
      const week = everyNWeeks.find((x) => x.value === (recurrence.weeks_count || recurrence.interval))
      setSelectedEveryNTimes(week)
    }
  }, [recurrence && (recurrence.weeks_count || recurrence.interval)])
  useEffect(() => {
    if ((editMode || previewEditMode) && recurrence.week_of_month > 0) {
      const week = nthWeekOfMonth.find((x) => x.value == recurrence.week_of_month)
      setSelectedNthWeekOfMonth(week)
    }
  }, [recurrence && recurrence.week_of_month])

  useEffect(() => {
    //week_of_month and occurence_in_month hold same data.
    // mixr information api uses week_of_month name and draft information api uses occurence_in_month name
    if ((editMode || previewEditMode) && recurrence.occurence_in_month > 0) {
      const week = nthWeekOfMonth.find((x) => x.value == recurrence.occurence_in_month)
      setSelectedNthWeekOfMonth(week)
    }
  }, [recurrence && recurrence.occurence_in_month])
  useEffect(() => {
    if ((editMode || previewEditMode) && recurrence.day_of_week >= 0) {
      setSelectedWeekday(recurrence.day_of_week)
    }
  }, [recurrence && recurrence.day_of_week])

  useEffect(() => {
    if ((editMode || previewEditMode) && (recurrence.months_count || recurrence.interval)) {
      setEveryNMonth(recurrence.months_count || recurrence.interval)
    }
  }, [recurrence && (recurrence.months_count || recurrence.interval)])

  useEffect(() => {
    if (startDate.value && startTime.value) {
      const startFullDateTime = new Date(
        `${startDate.value.getFullYear()}-${startDate.value.getMonth() + 1}-${startDate.value.getDate()} ${
          startTime.value
        }`
      )
      const formattedStartDate = formatLastUpdateDate(startFullDateTime, appConstantSettings.DATE_FORMAT7, t)
      if (!editMode || previewEditMode) {
        dispatch(
          mixrActions.setMixrData([
            { key: 'local_start_at', value: formattedStartDate },
            { key: 'start_at', value: formattedStartDate }
          ])
        )
      }
    }
  }, [startDate, startTime])
  useEffect(() => {
    if (endDate.value && endTime.value) {
      const endFullDateTime = new Date(
        `${endDate.value.getFullYear()}-${endDate.value.getMonth() + 1}-${endDate.value.getDate()} ${endTime.value}`
      )
      const fomattedEndDate = formatLastUpdateDate(endFullDateTime, appConstantSettings.DATE_FORMAT7, t)
      if (!editMode || previewEditMode) {
        dispatch(
          mixrActions.setMixrData([
            { key: 'local_end_at', value: fomattedEndDate },
            { key: 'end_at', value: fomattedEndDate }
          ])
        )
      }
    }
  }, [endDate, endTime])
  useEffect(() => {
    if (untilDate && untilDate.value) {
      const formattedUntilDate = formatLastUpdateDate(untilDate.value, appConstantSettings.DATE_FORMAT8)
      if (!editMode || previewEditMode) {
        dispatch(
          mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, end_date: formattedUntilDate } }])
        )
      }
      if (previewEditMode) {
        validateRecurMixrEndDate()
      }
    }
  }, [untilDate])

  const handleEveryMonthChange = (e) => {
    setValueChanged(true)
    const value = e.target.value
    setEveryNMonth(value)
    if (!editMode || previewEditMode) {
      dispatch(mixrActions.setMixrData([{ key: 'recurrence', value: { ...recurrence, months_count: value } }]))
    }
  }
  const handleSave = () => {
    setInValidDateError('')

    if (validate()) {
      const startFullDateTime = new Date(
        `${startDate.value.getFullYear()}-${startDate.value.getMonth() + 1}-${startDate.value.getDate()} ${
          startTime.value
        }`
      )
      const formattedStartDate = formatLastUpdateDate(startFullDateTime, appConstantSettings.DATE_FORMAT7, t)
      const endFullDateTime = new Date(
        `${endDate.value.getFullYear()}-${endDate.value.getMonth() + 1}-${endDate.value.getDate()} ${endTime.value}`
      )
      const formattedEndDate = formatLastUpdateDate(endFullDateTime, appConstantSettings.DATE_FORMAT7, t)

      const data = {
        ...((mixrLocation?.timezone?.id || mixrLocation?.timezone?.timezone_id) && {
          timezone_id: mixrLocation?.timezone?.timezone_id || mixrLocation?.timezone?.id
        }),
        ...(recurrence.is_parent_event !== 1 ? { start_at: formattedStartDate, end_at: formattedEndDate } : {})
        // ...(selectedPricing.value === 1 && pricingDetails && pricingDetails.length > 0
        //   ? { fees: pricingDetails }
        //   : { fees: '' })
      }
      if (recurrence && recurrence.type !== 'none' && recurrence.is_parent_event !== 1) {
        openEditMixrPopup()
        setDataToUpdateForRecMixr(data)
      } else {
        dispatch(mixrActions.editMixr(mixrId, data))
      }
    }
  }
  const handleCancel = () => {
    setValueChanged(false)
    ///for timezone
    dispatch(mixrActions.setMixrData([{ key: 'location', value: { ...mixrLocation, timezone: initialTimezone } }]))
    /////
    const { type: recurrenceType } = recurrence
    const startingDate = new Date(startDatetime)
    let hrs = startingDate.getHours()
    hrs = hrs < 10 ? `0${hrs}` : hrs
    let mins = startingDate.getMinutes()
    mins = mins < 10 ? `0${mins}` : mins
    const startingTime = `${hrs}:${mins}`
    setStartDate({
      ...startDate,
      value: startingDate
    })
    setStartTime({
      ...startTime,
      value: startingTime
    })
    setStartingEndTime(startingDate)

    const endingDate = new Date(endDatetime)
    let hrsEnd = endingDate.getHours()
    hrsEnd = hrsEnd < 10 ? `0${hrsEnd}` : hrsEnd
    let minsEnd = endingDate.getMinutes()
    minsEnd = minsEnd < 10 ? `0${minsEnd}` : minsEnd
    const endingTime = `${hrsEnd}:${minsEnd}`

    setEndDate({
      ...endDate,
      value: endingDate
    })
    setEndTime({
      ...endTime,
      value: endingTime
    })
    if (recurrenceType !== 'none') {
      let diffDays = endingDate.getDate() - startingDate.getDate()
      const endsOn = mixrEndsOnTypes.find((x) => x.value === diffDays)
      setSelectedMixrEndsOn(endsOn)
      setSelectedRecurrenceId(0)
      const repeatType = repeatTypes.find((x) => x.value === recurrenceType)
      setSelectedRepeatType(repeatType)
    } else {
      setSelectedRecurrenceId(1)
    }
    if (recurrenceType === 'weekly') {
      setSelectedDays(
        recurDaysOfWeek.split(',').map(function (item) {
          return parseInt(item, 10)
        })
      )
      const everyNWeek = everyNWeeks.find((x) => x.value == recurWeeksCount)
      setSelectedEveryNTimes(everyNWeek)
    }
    if (recurrenceType === 'monthly') {
      setEveryNMonth(recurMonthsCount)
      const occurence = nthWeekOfMonth.find((x) => x.value == recurOccurenceInMonth)
      setSelectedNthWeekOfMonth(occurence)
      setSelectedWeekday(recurDayOfWeek)
    }
  }

  const handleSelectTimezone = (selectedTimezone) => {
    if (selectedTimezone) {
      setValueChanged(true)
      dispatch(mixrActions.setMixrData([{ key: 'location', value: { ...mixrLocation, timezone: selectedTimezone } }]))
    }
  }

  const handleAllDay = () => {
    const changedAllDay = !allDayMixr
    setAllDayMixr(changedAllDay)
    if (changedAllDay) {
      handleStartTimeChange({ value: '00:00' })
      handleEndTimeChange({ value: '23:59' })
    } else {
      const startTimeValue = roundTimeQuarterHour(new Date())
      const endTimeValue = roundTimeQuarterHour(new Date(), 1)
      handleStartTimeChange({ value: startTimeValue })
      handleEndTimeChange({ value: endTimeValue })
    }
  }

  return (
    <React.Fragment>
      {(recurrence?.is_parent_event !== 1 || !editMode) && (
        <React.Fragment>
          <PureTitle title={t('event.create.timing.timingTitle')} isRequired={true} />
          <RadioButtonGroup
            label={t('event.create.mixrType')}
            isDisabled={editMode}
            items={recurrenceTypes}
            selectedItemValue={selectedRecurrenceId.toString()}
            onChange={handleRecurrenceChange}
            radioContainerCSS={styles.radioContainerCSS}
            labelCSS={parentStyles.labelCSS}
          />
          <div className={styles.mainTable}>
            <div className={`${styles.row} ${styles.row1}`}>
              <div className={`${styles.leftCol}`}>
                <Label
                  className={`${styles.label} ${styles.labelBeginEnd}`}
                  ariaLabel={t('event.create.timing.begins')}>
                  {t('event.create.timing.begins')}
                </Label>
                <Calendar
                  defaultDate={new Date()}
                  date={startDate.value}
                  setRef={setStartDateRef}
                  minDate={new Date()}
                  handleDateChange={handleStartDateChange}
                  containerCSS={styles.calendar}
                  calendarCSS={styles.calendarControl}
                />
              </div>
              {!allDayMixr && (
                <div className={`${styles.rightCol}`}>
                  <Label className={`${styles.label} ${styles.labelAt}`} ariaLabel={t('global.at')}>
                    {t('global.at')}
                  </Label>
                  <TimePicker
                    time={startTime.value}
                    setRef={setStartTimeRef}
                    handleTimeChange={handleStartTimeChange}
                    className={styles.timePicker}
                    isMobile={isMobile}
                    menuPortalTarget={true}
                  />
                  <Timezone
                    handleSelectTimezone={handleSelectTimezone}
                    isVirtual={attending_type === 'virtual'}
                    currentTimezone={mixrLocation?.timezone}
                  />
                  {startTime && startTime.hasError && (
                    <ErrorMessage text={startTime.errorMessage} className={parentStyles.error} />
                  )}
                </div>
              )}
            </div>
            <div className={`${styles.row} ${styles.row2}`}>
              <div className={`${styles.leftCol}`}>
                <Label className={`${styles.label} ${styles.labelBeginEnd}`} ariaLabel={t('event.create.timing.ends')}>
                  {t('event.create.timing.ends')}
                </Label>
                {selectedRecurrenceId === 1 ? (
                  <Calendar
                    defaultDate={new Date()}
                    date={endDate.value}
                    setRef={setEndDateRef}
                    minDate={startDate.value || new Date()}
                    handleDateChange={handleEndDateChange}
                    containerCSS={styles.calendar}
                    calendarCSS={styles.calendarControl}
                  />
                ) : (
                  <Dropdown1
                    className={styles.mixrEndOnDropdown}
                    value={selectedMixrEndsOn}
                    options={mixrEndsOnTypes}
                    //  className={styles.selectAttendanceLimitContainer}
                    onChange={handleMixrEndsOnChange}
                    isSearchable={false}
                    menuPortalTarget={true}
                  />
                )}
              </div>
              {!allDayMixr && (
                <div className={`${styles.rightCol}`}>
                  <Label className={`${styles.label} ${styles.labelAt}`} ariaLabel={t('global.at')}>
                    {t('global.at')}
                  </Label>
                  <TimePicker
                    time={endTime.value}
                    setRef={setEndTimeRef}
                    handleTimeChange={handleEndTimeChange}
                    className={styles.timePicker}
                    isMobile={isMobile}
                    startingTime={selectedRecurrenceId === 1 ? startingEndTime : null}
                    menuPortalTarget={true}
                  />
                  <Timezone
                    handleSelectTimezone={handleSelectTimezone}
                    currentTimezone={mixrLocation?.timezone}
                    isVirtual={attending_type === 'virtual'}
                  />
                  {endTime && endTime.hasError && (
                    <ErrorMessage text={endTime.errorMessage} className={parentStyles.error} />
                  )}
                </div>
              )}
            </div>
            <div className={`${styles.rowErrors}`}>
              {inValidDateError.length > 0 && (
                <ErrorMessage text={inValidDateError} className={`${parentStyles.error}  ${styles.errorCenter}`} />
              )}
            </div>
            <div className={styles.chkAllDay}>
              <Checkbox
                customClassName={styles.checkBoxAgree}
                checked={allDayMixr}
                name='chkAllDay'
                onChange={handleAllDay}
              />
              <span className={styles.text}>{t('event.create.timing.allDay')}</span>
            </div>
            {editMode && selectedRecurrenceId === 0 ? (
              selectedRepeatType.value === 'daily' ? (
                <div role='alert' aria-live='polite' className={styles.recurrentDetails}>
                  {t('event.create.timing.dailyMixr')}
                </div>
              ) : selectedRepeatType.value === 'weekly' ? (
                <div
                  role='alert'
                  aria-live='polite'
                  className={styles.recurrentDetails}
                  dangerouslySetInnerHTML={{
                    __html: t('event.create.timing.weeklyMixr', {
                      selectedDayNames: selectedDays.map((d) => days[d].full).join(', '),
                      interval: selectedEveryNTimes.label
                    })
                  }}
                />
              ) : selectedRepeatType.value === 'monthly' ? (
                <div
                  role='alert'
                  aria-live='polite'
                  className={styles.recurrentDetails}
                  dangerouslySetInnerHTML={{
                    __html: t('event.create.timing.monthlyMixr', {
                      weekDayName: days[selectedWeekday - 1].full,
                      interval: everyNMonth,
                      weekOfMonth: selectedNthWeekOfMonth.label
                    })
                  }}
                />
              ) : null
            ) : null}
            {!editMode && selectedRecurrenceId === 0 && (
              <React.Fragment>
                <div className={`${styles.row} ${styles.row3}`}>
                  <div className={`${styles.leftCol}`}>
                    <Label ariaLabel={t('event.create.timing.repeats')} className={`${styles.labelRepeats}`}>
                      {t('event.create.timing.repeats')}
                    </Label>
                    <Dropdown1
                      isDisabled={editMode}
                      className={`${styles.dropdown} ${styles.repeatDropdown}`}
                      value={selectedRepeatType}
                      options={repeatTypes}
                      onChange={handleRepeatTypeChange}
                      isSearchable={false}
                    />
                  </div>

                  <div
                    className={`${styles.rightCol} ${
                      selectedRepeatType.value === 'monthly' && styles.rightColPaddingLeft
                    }`}>
                    {selectedRepeatType.value === 'weekly' ? (
                      <React.Fragment>
                        <Label ariaLabel={t('event.create.timing.every')} className={styles.label}>
                          {t('event.create.timing.every')}
                        </Label>
                        <Dropdown1
                          isDisabled={editMode}
                          className={styles.dropdown}
                          value={selectedEveryNTimes}
                          options={everyNWeeks}
                          onChange={handleEveryNWeeksChange}
                          isSearchable={false}
                        />
                      </React.Fragment>
                    ) : selectedRepeatType.value === 'monthly' ? (
                      <React.Fragment>
                        <Label ariaLabel={t('event.create.timing.every')} className={styles.label}>
                          {t('event.create.timing.every')}
                        </Label>

                        <Input
                          disabled={editMode}
                          type='number'
                          value={everyNMonth}
                          className={styles.monthInput}
                          size=''
                          onChange={handleEveryMonthChange}
                        />

                        <Label
                          ariaLabel={t('event.create.timing.month')}
                          className={`${styles.label} ${styles.labelMarginLeft}`}>
                          {t('event.create.timing.month')}
                        </Label>
                      </React.Fragment>
                    ) : null}
                  </div>
                </div>
                <div className={`${styles.rowErrors} ${styles.row3Errors}`}>
                  <div className={styles.leftCol}></div>
                  <div className={styles.rightCol}>
                    {(everyMonth == '' || everyNMonth <= 0) && (
                      <ErrorMessage
                        text={t('event.create.clientErrors.everyNMonthRequired')}
                        className={`${parentStyles.error} ${styles.error}`}
                      />
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}

            {!editMode && selectedRecurrenceId === 0 && selectedRepeatType.value === 'weekly' && (
              <React.Fragment>
                <div className={`${styles.row} ${styles.row4}`}>
                  <div className={`${styles.leftCol} ${styles.leftColFullWidth}`}>
                    <Label ariaLabel={t('global.on')} className={`${styles.label} ${styles.labelW10}`}>
                      {t('global.on')}
                    </Label>

                    <ul className={styles.days}>
                      {days.map((d) => {
                        const selected = selectedDays.includes(d.value)
                        return (
                          <li>
                            {editMode ? (
                              <div
                                aria-label=''
                                type='button'
                                className={`${styles.buttonDay} ${selected && styles.divDaySelected}`}>
                                {d.label}
                              </div>
                            ) : (
                              <button
                                aria-label=''
                                type='button'
                                onClick={() => handleDaysSelection(d)}
                                className={`${styles.buttonDay} ${selected && styles.buttonDaySelected}`}>
                                {d.label}
                              </button>
                            )}
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
                <div className={`${styles.rowErrors} ${styles.row4Errors}`}>
                  <div className={styles.leftCol}>
                    {hasSelectedDaysError && (
                      <ErrorMessage
                        text={t('event.create.clientErrors.selectedDaysError')}
                        className={`${parentStyles.error} ${styles.error}`}
                      />
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}
            {!editMode && selectedRecurrenceId === 0 && selectedRepeatType.value === 'monthly' && (
              <React.Fragment>
                <div className={`${styles.row} ${styles.row5}`}>
                  <div className={styles.leftCol}>
                    <Label
                      ariaLabel={t('event.create.timing.occursEvery')}
                      className={`${styles.label} ${styles.labelW50}`}>
                      {t('event.create.timing.occursEvery')}
                    </Label>

                    <Dropdown1
                      isDisabled={editMode}
                      className={`${styles.dropdown} ${styles.everyMonthDropdown}`}
                      value={selectedNthWeekOfMonth}
                      options={nthWeekOfMonth}
                      onChange={handleNthWeekOfMonthChange}
                      isSearchable={false}
                    />
                  </div>
                  <div className={`${styles.rightCol} ${styles.rightColPaddingLeft}`}>
                    <WeekdayDropdown
                      isDisabled={editMode}
                      className={`${styles.dropdown} ${styles.weekdayDropdown}`}
                      selectedWeekdayValue={selectedWeekday}
                      handleWeekdayChange={handleWeekdayChange}
                    />
                  </div>
                </div>
                <div className={`${styles.rowErrors} ${styles.row5Errors}`}>
                  <div className={styles.leftCol}>
                    {selectedNthWeekOfMonthError && (
                      <ErrorMessage
                        text={selectedNthWeekOfMonthError}
                        className={`${parentStyles.error} ${styles.error}`}
                      />
                    )}
                  </div>
                  <div className={styles.rightCol}>
                    {selectedWeekdayError && (
                      <ErrorMessage text={selectedWeekdayError} className={`${parentStyles.error} ${styles.error}`} />
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}
            {(!editMode || previewEditMode) && selectedRecurrenceId === 0 && (
              <React.Fragment>
                <div className={`${styles.row} ${styles.row6}`}>
                  <div className={styles.leftCol}>
                    <Label className={`${styles.label} ${styles.labelW10}`} ariaLabel={t('event.create.timing.until')}>
                      {t('event.create.timing.until')}
                    </Label>{' '}
                    <Calendar
                      containerCSS={styles.calendar}
                      date={untilDate.value}
                      handleDateChange={handleUntilDateChange}
                      calendarCSS={`${styles.calendarControl} ${styles.untilCalendarControl}`}
                    />
                  </div>
                </div>
                <div className={`${styles.rowErrors} ${styles.row6Errors}`}>
                  <div className={styles.leftCol}>
                    {untilDate && untilDate.hasError && (
                      <ErrorMessage text={untilDate.errorMessage} className={`${parentStyles.error} ${styles.error}`} />
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}

            {showInvalidEndDateError && recurEndDateError && (
              <ErrorMessage className={`${parentStyles.error} ${styles.error}`}>
                {recurEndDateError.map((e) => (
                  <p className={styles.recurEndError}>{e}</p>
                ))}
              </ErrorMessage>
            )}

            {showInvalidEndDateError && recurrentMixrsCount === 0 && (
              <ErrorMessage
                text={t('event.create.clientErrors.invalidRecurMixrTimingSetting')}
                className={`${parentStyles.error} ${styles.errorCenter}`}
              />
            )}
          </div>
        </React.Fragment>
      )}

      {editMode ? (
        valueChanged ? (
          <div className={parentStyles.buttons}>
            <Button style='secondary' text={t('global.cancel')} handleClick={handleCancel} />
            <Button
              type='button'
              handleClick={handleSave}
              text={
                editLoading && recurrence && (recurrence.type === 'none' || recurrence.is_parent_event === 1) ? (
                  <Spinner isWhite={true} />
                ) : (
                  t('global.save')
                )
              }
            />
          </div>
        ) : null
      ) : !hideNextButton ? (
        <div className={parentStyles.buttons}>
          <Button text={t('global.btnNext')} handleClick={handleNext} />
        </div>
      ) : null}
    </React.Fragment>
  )
}

const add1hourToTime = (time) => {
  const timeArray = time.value.split(':')
  let hrs = timeArray[0]
  let mins = timeArray[1]
  let intHrs = parseInt(hrs)
  intHrs = intHrs === 23 ? 0 : intHrs + 1
  hrs = intHrs < 10 ? `0${intHrs}` : intHrs.toString()

  return `${hrs}:${mins}`
}
